export default {
  businesses: [],
  businessesCount: 0,
  query: '',
  limit: 10,
  skip: 0,
  sort: {}
}
